import StudyTypeEnum from "../../../enums/StudyTypeEnum";
import {DATE_OPTIONS, getDateFromNow} from "../../../core/utils/date-utils";

/**
 * Çekim grid'inin hazır iş listesi filtreleri.
 *
 * TEK KAYNAK: sol paneldeki "Hızlı Filtreler" açılır listesi ve grid üstündeki hızlı filtre çubuğu
 * (StudyQuickFilterBar) aynı tanımı kullanır. label hem i18n anahtarı hem de filtrede saklanan
 * `quickFilters` değeridir.
 */
export const quickFilters = (userId) => [
    {
        label: 'Emergency, Readings',
        filters: {
            studyTypeList: [StudyTypeEnum.EMERGENCY],
            isRead: false,
            isReportable: true,
            studyStatus: [0, 3],
        }
    },
    {
        label: 'Emergency, to Write',
        filters: {
            studyTypeList: [StudyTypeEnum.EMERGENCY],
            isRead: true,
            studyStatus: [0, 3],
            isReportable: true
        }
    },
    {
        label: 'What I will read',
        filters: {
            assignDoctor: userId,
            isRead: false,
            studyTypeList: [],
            isReportable: true,
            studyStatus: [0, 3],
        }
    },
    {
        label: 'What I will write',
        filters: {
            assignReporter: userId,
            isRead: true,
            studyTypeList: [],
            studyStatus: [0, 3],
            isReportable: true
        }
    },
    {
        label: 'Routine readings',
        filters: {
            studyTypeList: [StudyTypeEnum.INPATIENT, StudyTypeEnum.ROUTINE, StudyTypeEnum.COMPARATIVE_EXAMINATION],
            isRead: false,
            isReportable: true,
            studyStatus: [0, 3],
        }
    },
    {
        label: 'Routine writings',
        filters: {
            studyTypeList: [StudyTypeEnum.INPATIENT, StudyTypeEnum.ROUTINE, StudyTypeEnum.COMPARATIVE_EXAMINATION],
            isRead: true,
            studyStatus: [0, 3],
            isReportable: true
        }
    },
    {
        label: 'To be read',
        filters: {
            isRead: false,
            studyTypeList: [],
            isReportable: true,
            studyStatus: [0, 3],
        }
    },
    {
        label: 'To be write',
        filters: {
            isRead: true,
            studyTypeList: [],
            studyStatus: [0, 3],
            isReportable: true
        }
    },
]

/**
 * Hazır filtre uygulanmadan önce sıfırlanan alanlar: bir hazır filtreden ötekine geçince öncekinin
 * alanı (ör. assignDoctor) filtrede asılı kalmasın. Tüm hazır filtrelerin dokunduğu alan kümesi budur.
 */
export const QUICK_FILTER_RESET = {
    isRead: null,
    studyTypeList: [],
    studyStatus: [],
    assignDoctor: null,
    assignReporter: null,
}

export const getDefaultReceivedDate = () => {
    const date = getDateFromNow(DATE_OPTIONS.LAST_5_DAYS);
    return [date.start, date.end]
}

/** Sayfanın ilk açılış filtresi (son 5 günün gelişleri, silinmemiş, raporlanabilir). */
export const buildDefaultStudyFilter = () => {
    const date = getDefaultReceivedDate();

    return {
        studyReceivedDateTimeBegin: date[0],
        studyReceivedDateTimeEnd: date[1],
        isDeleted: false,
        isReportable: true,
    }
}
